<template>
  <div class="root-area-limit">

    <div class="bg-top">
      <img class="img-top" ref="topBg" :src="imgTop" alt="">
    </div>

    <main class="main-wrap">
      <div
        class="msg-wrap"
        v-for="(config, index) in msgConfig"
        :key="index"
      >
        <BlockMsg
          v-if="config.show"
          :img-id="config.imgUrl"
          :title="config.title"
          :msg="config.msg"
        />
      </div>
    </main>

    <div class="bg-bottom">
      <img class="img-bot" ref="botBg" :src="imgBot" alt="">
    </div>

  </div>
</template>

<script>
import BlockMsg from './components/BlockMsg.vue'
import picUfo from '../../../public/img/ufo.svg'
import picUfoTablets from '../../../public/img/ufo_768.svg'
import picUfoDesktop from '../../../public/img/ufo_1075.svg'
import picCity from '../../../public/img/city.svg'
import picCityTablets from '../../../public/img/city_768.svg'
import picCityDesktop from '../../../public/img/city_2560.svg'

export default {
  components: {
    BlockMsg
  },
  data () {
    return {
      fullWidth: null,
      imgTop: picUfo,
      imgBot: picCity,
      isCh: false
    }
  },
  computed: {
    msgConfig () {
      const res = [
        {
          imgUrl: 'china.svg',
          title: '亲爱客户：',
          show: this.isCh,
          msg: '您当前所在地区限制，无法浏览您所尝试打开网页。我们对您造成的不便表示万分歉意。'
        },
        {
          imgUrl: 'united-kingdom.svg',
          title: 'Dear Valued Customers:',
          show: true,
          msg: 'The page that you are trying to access has been restricted in this location.We apologize for any inconvenience caused.'
        },
        {
          imgUrl: 'thailand.svg',
          title: 'เรียนลูกค้าผู้มีอุปการะคุณ:',
          show: true,
          msg: 'หน้าจอแสดงผลที่คุณพยายามเชื่อมต่อ ได้ถูกจำกัด เราขอแสดงความเสียใจใน ความไม่สะดวกมายัง ณ.'
        },
        {
          imgUrl: 'indonesia.svg',
          title: 'Kepada Para Pelanggan Terhormat:',
          show: true,
          msg: 'Lokasi di mana Anda mencoba untuk mengakses halaman ini telah dilarang.Kami mohon maaf atas ketidaknyamanan yang terjadi.'
        },
        {
          imgUrl: 'vietnam.svg',
          title: 'Kính chào Quý Khách:',
          show: true,
          msg: 'Đường dẫn mà quý khách đang truy nhập trên trang này bị hạn chế.Chúng tôi thành thật xin lỗi cho những bất tiện gây ra.'
        }
      ]

      return res
    }
  },
  watch: {
    fullWidth () {
      if (this.fullWidth < 768) {
        this.imgTop = picUfo
        this.imgBot = picCity
      }

      if (this.fullWidth >= 768 && this.fullWidth < 1520) {
        this.imgBot = picCityTablets
      }

      if (this.fullWidth >= 1520) {
        this.imgBot = picCityDesktop
      }

      if (this.fullWidth >= 768 && this.fullWidth < 1920) {
        this.imgTop = picUfoTablets
      }

      if (this.fullWidth >= 1920) {
        this.imgTop = picUfoDesktop
      }
    }
  },
  beforeCreate () {
    document.body.className = 'area-limit'
  },
  mounted () {
    this.fullWidth = window.innerWidth
    this.fullHeight = window.innerHeight
    window.addEventListener('resize', this.resizeEvent)
    const date = new Date()
    this.isCh = date.toString().indexOf('GMT+0530') === -1 // 印度時區不顯示中文 包含印度 斯里蘭卡
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeEvent)
  },
  methods: {
    resizeEvent () {
      this.fullWidth = window.innerWidth
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "AreaLimit.styl"
</style>
